import { getPartnerProfile } from "../services/produktpartnerService";
import { partnerProfileToFormState } from "../components/produktpartner/partnerProfileModel";
// akteAnlageLaden.ts — Kontakt laden und in den Formular-State der Anlage
// übersetzen (Reiter „Allgemein" der Akte, AkteAllgemeinAnlage).
//
// Eine Stelle für beide Wege: das normale Laden und das Nachladen des neuen
// Stands, wenn jemand anderes inzwischen gespeichert hat (409, siehe
// kontaktKonflikt.ts). Beide MÜSSEN denselben Formular-State bauen, sonst sähe
// die Neuberechnung Unterschiede, wo keine sind.

import { apiUrl } from "./api";
import type { FormState } from "./formUtils";
import {
  contactToCompanyFormState,
  contactToPrivateFormState,
  type BranchengruppeZeile,
} from "./contactToFormState";
import { beziehungenFuerBearbeiten, kontaktTypVon } from "./bearbeitenBeziehungen";
import { branchengruppenLaden } from "../services/branchengruppeService";

type AnyRec = Record<string, any>;

export const alsFormState = (o: AnyRec): FormState => {
  const out: FormState = {};
  for (const [k, v] of Object.entries(o)) {
    if (v == null) continue;
    out[k] = typeof v === "object" ? JSON.stringify(v) : (v as any);
  }
  return out;
};

/** Formular-State aus dem geladenen Kontakt (Firma: samt weiteren Branchen). */
export async function felderAusKontakt(c: AnyRec, contactId: number): Promise<FormState> {
  const typ = kontaktTypVon(c);
  let branchengruppen: BranchengruppeZeile[] | undefined;
  if (typ === "Firma") {
    try {
      branchengruppen = (await branchengruppenLaden(contactId)) as unknown as BranchengruppeZeile[];
    } catch {
      branchengruppen = undefined;
    }
  }
  const basis = typ === "Firma" ? contactToCompanyFormState(c, { branchengruppen }) : contactToPrivateFormState(c);
  const profil = typ !== "Firma" && ["Ansprechpartner Produktpartner", "Ansprechpartner Kooperationspartner"].includes(String(c.status?.status ?? c.statusName))
    ? partnerProfileToFormState(await getPartnerProfile(contactId)) : {};
  return alsFormState({ ...basis, ...profil, ...beziehungenFuerBearbeiten(c) });
}

export async function akteAnlageLaden(contactId: number): Promise<{ kontakt: AnyRec; felder: FormState }> {
  const res = await fetch(apiUrl(`contact/${contactId}`, { include: "relations,relations-deep" }), {
    credentials: "include",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const c = (await res.json()) as AnyRec;
  return { kontakt: c, felder: await felderAusKontakt(c, contactId) };
}
